export enum Languages {
  PTBR = 'pt-BR',
  EN = 'en',
  ES = 'es',
}